import React from 'react'
import { connect } from 'react-redux'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import StickyNavBottom from '~/Common-Objects/Navigation/StickNavBottom'
import i18n from '~/i18n'
import Theme from '~/pages/cp/templates/add/dragDrop/themes/theme'
import SelectFormType from './components/selectFormType'
import SelectGatedContent from '~/Common-Objects/GatedContent/selectGatedContent'
import AiFormGenerate from './aiGenerate'
import DisplayCard from '~/Common-Objects/UI/DisplayCard'
import ChoiceIllustration from '~/pages/cp/includes/aiCreateWizard/choiceArt'
import { canUseAiTemplateBuilder } from '~/utils/aiTemplateBuilder'
import { alterSiteDrawer } from '~/data/actions/siteActions'
import '~/pages/cp/includes/aiCreateWizard/style.scss'

export const NORMAL_FORM = 'form'
export const GATED_CONTENT = 'gated'

@connect((store) => {
    return { accountMaster: store.accountMaster, siteMaster: store.siteMaster }
})
export default class FormPicker extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 0,
            formType: NORMAL_FORM,
            themeType: 0,
            loadingThemes: true,
            themes: [],
            content: [],
            contentAccess: 'email',
            scratchMode: false,
            aiMode: false
        }

        this.selectType = this.selectType.bind(this)
        this.changeThemeType = this.changeThemeType.bind(this)
        this.selectTheme = this.selectTheme.bind(this)
        this.getThemes = this.getThemes.bind(this)
        this.saveFileSettings = this.saveFileSettings.bind(this)
        this.removeContent = this.removeContent.bind(this)
        this.addLink = this.addLink.bind(this)
        this.addFile = this.addFile.bind(this)
        this.handleContentAccessChange = this.handleContentAccessChange.bind(this)
    }

    componentDidMount() {
        if (this.props.formType) {
            this.setState({ formType: this.props.formType, step: this.props.formType == 'gated' ? 1 : 2 })
        }
        this.getThemes()
    }

    changeThemeType(newVal) {
        this.setState({ themeType: newVal }, this.getThemes)
    }

    selectType(type) {
        this.setState({
            formType: type,
            step: type === NORMAL_FORM ? 2 : 1,
            scratchMode: false,
            aiMode: false
        })
    }

    getThemes() {
        axios.get('/theme?type=2&formType=' + this.state.themeType).then((response) => {
            this.setState({
                loadingThemes: false,
                themes: response.data.Themes
            })
        })
    }

    selectTheme(theme) {
        this.props.save(
            theme,
            this.state.themeType,
            this.state.formType === GATED_CONTENT
                ? { files: this.state.content, serve: this.state.contentAccess }
                : undefined
        )
    }

    saveFileSettings(file, settings) {
        const newContent = [...this.state.content]
        const fileIndex = newContent.findIndex((el) => el === file)
        newContent[fileIndex] = {
            ...file,
            settings
        }

        this.setState({ content: newContent })
    }

    removeContent(item) {
        const newContent = [...this.state.content]
        const contentIndex = newContent.findIndex((el) => el === item)
        newContent.splice(contentIndex, 1)

        this.setState({ content: newContent })
    }

    addLink(url) {
        this.setState((prevState) => ({
            content: [...prevState.content, { type: 1, url, settings: {} }]
        }))
    }

    addFile(file) {
        this.setState((prevState) => ({
            content: [...prevState.content, { type: 0, FileManagerFile: file, settings: {} }]
        }))
    }

    async handleContentAccessChange(access) {
        this.setState({ contentAccess: access })
    }

    render() {
        var thisHeader = i18n.t('campaigns:overview.hostedForm')
        var thisSubHeader = i18n.t('campaigns:overview.hostedFormDesc')
        if (this.state.themeType == 1) {
            thisHeader = i18n.t('campaigns:overview.embeddedForm')
            thisSubHeader = i18n.t('campaigns:overview.embeddedFormDesc')
        }
        if (this.state.themeType == 2) {
            thisHeader = i18n.t('campaigns:overview.popupForm')
            thisSubHeader = i18n.t('campaigns:overview.popupFormDesc')
        }
        if (this.state.themeType == 3) {
            thisHeader = i18n.t('campaigns:overview.popupForm')
            thisSubHeader = i18n.t('campaigns:overview.popupFormDesc')
        }

        const showAi =
            canUseAiTemplateBuilder(this.props.accountMaster, this.props.siteMaster) &&
            Boolean(this.props.groupId && this.props.history)
        const showAiChoice =
            showAi &&
            this.state.formType === NORMAL_FORM &&
            this.state.step === 2 &&
            !this.state.scratchMode &&
            !this.state.aiMode

        return (
            <div>
                {this.state.step === 0 && <SelectFormType onSelect={this.selectType} />}
                {this.state.step === 1 && (
                    <>
                        <div className='center-xs mar-b60'>
                            <h1 className='h2 mar-b10'>Configure gated content</h1>
                            <p className='text-md text-grey'>
                                Allow visitors to download files or gain access to links
                            </p>
                        </div>

                        <Row>
                            <Column xs={12} lg={10} className='col-lg-offset-1'>
                                <SelectGatedContent
                                    content={this.state.content}
                                    contentAccess={this.state.contentAccess}
                                    onAddFile={this.addFile}
                                    onSaveFileSettings={this.saveFileSettings}
                                    onAddLink={this.addLink}
                                    onDelete={this.removeContent}
                                    onContentAccessChange={this.handleContentAccessChange}
                                    onSubmit={() => this.setState({ step: 2 })}
                                />
                            </Column>
                        </Row>
                    </>
                )}

                {showAiChoice && (
                    <div className='ai-create-wizard' data-test='ai-form-choice'>
                        <div className='ai-create-wizard__header'>
                            <h2 className='ai-create-wizard__title'>{i18n.t('form:add.type.choiceTitle')}</h2>
                            <p className='ai-create-wizard__subtitle'>{i18n.t('form:add.type.choiceSubtitle')}</p>
                        </div>
                        <div className='ai-create-wizard__cards ai-create-wizard__cards--2'>
                            <div data-test='ai-form-path-scratch'>
                                <DisplayCard
                                    className='ai-create-wizard__card'
                                    onClick={() => this.setState({ scratchMode: true })}
                                >
                                    <DisplayCard.Content>
                                        <div className='ai-create-wizard__card-art'>
                                            <ChoiceIllustration variant='formTemplate' />
                                        </div>
                                        <h4 className='mar-b10'>{i18n.t('form:add.type.scratchTitle')}</h4>
                                        <p>{i18n.t('form:add.type.scratchBody')}</p>
                                    </DisplayCard.Content>
                                </DisplayCard>
                            </div>
                            <div data-test='ai-form-path-generate'>
                                <DisplayCard
                                    className='ai-create-wizard__card'
                                    onClick={() => this.setState({ aiMode: true })}
                                >
                                    <DisplayCard.Content>
                                        <div className='ai-create-wizard__card-art'>
                                            <ChoiceIllustration variant='formAi' />
                                        </div>
                                        <h4 className='mar-b10'>{i18n.t('form:add.type.generateTitle')}</h4>
                                        <p>{i18n.t('form:add.type.generateBody')}</p>
                                    </DisplayCard.Content>
                                </DisplayCard>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.aiMode && (
                    <AiFormGenerate
                        history={this.props.history}
                        groupId={this.props.groupId}
                        initialFormType={this.state.themeType}
                        onBack={() => this.setState({ aiMode: false })}
                        onClose={() => this.props.dispatch(alterSiteDrawer(false, true, 'right', null, true, null))}
                    />
                )}

                {this.state.step === 2 && !showAiChoice && !this.state.aiMode && (
                    <>
                        <div style={{ paddingBottom: showAi ? 80 : 0 }}>
                            <div className='text-center mar-b25'>
                                <ButtonSimple
                                    className='button-simple-fullsize'
                                    selected={this.state.themeType == 0}
                                    onClick={() => {
                                        this.changeThemeType(0)
                                    }}
                                >
                                    {i18n.t('hosted')}
                                </ButtonSimple>
                                <ButtonSimple
                                    className='button-simple-fullsize mar-l5'
                                    selected={this.state.themeType == 1}
                                    onClick={() => {
                                        this.changeThemeType(1)
                                    }}
                                >
                                    {i18n.t('embedded')}
                                </ButtonSimple>
                                {/* <ButtonSimple
                className="button-simple-fullsize mar-l5"
                selected={this.state.themeType == 2}
                onClick={() => {
                  this.changeThemeType(2);
                }}
              >
                Popup
              </ButtonSimple> */}
                            </div>
                            {showAi && this.state.formType === NORMAL_FORM && this.state.scratchMode ? (
                                <StickyNavBottom>
                                    <div
                                        className='quickFlex'
                                        style={{
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%'
                                        }}
                                    >
                                        <Button
                                            iconLeft={<Icons icon='arrowLeft' />}
                                            onClick={() => this.setState({ scratchMode: false })}
                                        >
                                            {i18n.t('form:add.aiGenerate.back')}
                                        </Button>
                                    </div>
                                </StickyNavBottom>
                            ) : null}
                            <div>
                                <Paper>
                                    {this.state.loadingThemes && (
                                        <div style={{ marginTop: '50px' }}>
                                            <LoadingIcons iconType='2' width='100px' />
                                        </div>
                                    )}

                                    {!this.state.loadingThemes && (
                                        <div>
                                            <h4 className='mar-b15'>{thisHeader}</h4>
                                            <div className='mar-b25'>{thisSubHeader}</div>

                                            {!this.state.themes.length && (
                                                <div
                                                    style={{ width: '100%' }}
                                                    className='center-xs center-sm center-md center-lg mar-t30'
                                                >
                                                    <span>{i18n.t('campaigns:overview.NoFormTemplateFound')}</span>
                                                </div>
                                            )}
                                            {this.state.themes.length > 0 && (
                                                <Row>
                                                    {this.state.themes.map((theme, index) => {
                                                        return (
                                                            <Column
                                                                xs={12}
                                                                sm={6}
                                                                md={4}
                                                                lg={4}
                                                                className='themes-advanced'
                                                                key={index}
                                                            >
                                                                <Theme
                                                                    theme={theme}
                                                                    className='extraSpace'
                                                                    select={() => {
                                                                        this.selectTheme(theme)
                                                                    }}
                                                                    preview={(event) => this.selectTheme(theme)}
                                                                />
                                                            </Column>
                                                        )
                                                    })}
                                                </Row>
                                            )}
                                        </div>
                                    )}
                                </Paper>
                            </div>
                        </div>
                    </>
                )}
            </div>
        )
    }
}
